<template>
  <p :class="cn('tw:text-sm tw:text-muted-foreground tw:mb-0', props.class)">
    <slot />
  </p>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
